module.exports = __webpack_public_path__ + "8712c90255d087c8c97f9eb5ec66c936.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/Impressum.jpg
// module id = 759
// module chunks = 0